module.exports = __webpack_public_path__ + "static/media/memo.61445c07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/memo.svg
// module id = 982
// module chunks = 0